var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_c('transition',{attrs:{"name":"transition--tips"}},[_c('div',{key:'TIP__' + _vm.view + _vm.tip,staticClass:"tips__tip",domProps:{"innerHTML":_vm._s(_vm.tips[_vm.view][_vm.tip])}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }